import { ResearchUnitRepository } from '@/domain/research-unit/ResearchUnitRepository';
import { AxiosInstance } from 'axios';
import { ResearchUnit } from '@/domain/research-unit/ResearchUnit';
import { RestResearchUnit, toResearchUnit } from '@/secondary/research-unit/RestResearchUnit';
import { NotFound } from '@/domain/NotFound';
import { InMemoryCache } from '@/secondary/InMemoryCache';

export class RestResearchUnitRepository implements ResearchUnitRepository {
  constructor(private axiosInstance: AxiosInstance, private inMemoryCache: InMemoryCache) {}

  list(): Promise<ResearchUnit[]> {
    return this.inMemoryCache.get<ResearchUnit[]>('research-units', () =>
      this.axiosInstance
        .get<RestResearchUnit[]>('/research-units')
        .then(response => response.data.map(toResearchUnit))
        .catch(error => {
          throw new NotFound('ResearchUnit').cause(error);
        })
    );
  }
}
